import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"
import _imports_0 from '@/assets/expert-program/directory/single-layout.svg'
import _imports_1 from '../../../../assets/expert-program/directory/grid-layout.svg'
import _imports_2 from '../../../../assets/expert-program/directory/row-layout.svg'


const _hoisted_1 = {
  key: 0,
  class: "fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50"
}
const _hoisted_2 = { class: "bg-white rounded-lg text-left p-6 w-full max-w-md" }
const _hoisted_3 = { class: "flex justify-between items-center mb-6" }
const _hoisted_4 = { class: "space-y-4" }
const _hoisted_5 = {
  key: 0,
  class: "absolute bottom-2 right-2 text-primary-purple"
}
const _hoisted_6 = ["innerHTML"]
const _hoisted_7 = {
  key: 0,
  class: "absolute bottom-2 right-2 text-primary-purple"
}
const _hoisted_8 = ["innerHTML"]
const _hoisted_9 = {
  key: 0,
  class: "absolute bottom-2 right-2 text-primary-purple"
}
const _hoisted_10 = ["innerHTML"]
const _hoisted_11 = {
  key: 0,
  class: "mt-4"
}
const _hoisted_12 = { class: "text-sm text-red-600 bg-red-50 border border-red-200 rounded-md p-3" }
const _hoisted_13 = {
  key: 0,
  class: "mb-1"
}
const _hoisted_14 = { key: 1 }
const _hoisted_15 = { class: "flex justify-end mt-6" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BaseButton = _resolveComponent("BaseButton")!
  const _component_BaseLabel = _resolveComponent("BaseLabel")!
  const _component_BaseInput = _resolveComponent("BaseInput")!

  return (_ctx.isVisible)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _cache[5] || (_cache[5] = _createElementVNode("h2", { class: "text-lg font-semibold text-gray-900" }, " Booking System Layout ", -1)),
            _createVNode(_component_BaseButton, {
              type: "button",
              onClick: _ctx.closeModal,
              class: "text-black hover:text-gray-600 transition-colors p-1"
            }, {
              default: _withCtx(() => _cache[4] || (_cache[4] = [
                _createTextVNode(" X ")
              ])),
              _: 1
            }, 8, ["onClick"])
          ]),
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", null, [
              _createVNode(_component_BaseLabel, {
                forAttr: "layoutName",
                text: "Layout Name",
                class: "block text-sm font-medium text-gray-700 mb-2"
              }),
              _createVNode(_component_BaseInput, {
                id: "layoutName",
                modelValue: _ctx.layoutName,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.layoutName) = $event)),
                type: "text",
                placeholder: "Enter layout name",
                className: "w-full p-2 border border-gray-300 rounded-md"
              }, null, 8, ["modelValue"])
            ]),
            _createElementVNode("div", {
              class: _normalizeClass(["p-2 border rounded-md cursor-pointer transition-all bg-white relative", 
            _ctx.selectedLayout === 'single'
              ? 'border-purple-600'
              : 'border-gray-300'
          ]),
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.selectLayout('single')))
            }, [
              _createElementVNode("div", {
                class: _normalizeClass(["flex justify-between items-center p-4 rounded transition-colors", 
              _ctx.selectedLayout === 'single' ? 'bg-purple-50' : 'bg-gray-100'
            ])
              }, _cache[6] || (_cache[6] = [
                _createElementVNode("span", { class: "text-sm font-medium text-gray-500" }, "Single Layout", -1),
                _createElementVNode("img", {
                  src: _imports_0,
                  alt: "Basic Layout",
                  class: "w-26 h-26"
                }, null, -1)
              ]), 2),
              (_ctx.selectedLayout === 'single')
                ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                    _createElementVNode("div", {
                      innerHTML: _ctx.CHECK_CIRCLE,
                      class: "w-5 h-5"
                    }, null, 8, _hoisted_6)
                  ]))
                : _createCommentVNode("", true)
            ], 2),
            _createElementVNode("div", {
              class: _normalizeClass(["p-2 border rounded-md cursor-pointer transition-all bg-white relative", 
            _ctx.selectedLayout === 'grid' ? 'border-purple-600' : 'border-gray-300'
          ]),
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.selectLayout('grid')))
            }, [
              _createElementVNode("div", {
                class: _normalizeClass(["flex justify-between items-center p-4 rounded transition-colors", _ctx.selectedLayout === 'grid' ? 'bg-purple-50' : 'bg-gray-100'])
              }, _cache[7] || (_cache[7] = [
                _createElementVNode("span", { class: "text-sm font-medium text-gray-500" }, "Grid Layout", -1),
                _createElementVNode("img", {
                  src: _imports_1,
                  alt: "Advanced Layout",
                  class: "w-26 h-26"
                }, null, -1)
              ]), 2),
              (_ctx.selectedLayout === 'grid')
                ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                    _createElementVNode("div", {
                      innerHTML: _ctx.CHECK_CIRCLE,
                      class: "w-5 h-5"
                    }, null, 8, _hoisted_8)
                  ]))
                : _createCommentVNode("", true)
            ], 2),
            _createElementVNode("div", {
              class: _normalizeClass(["p-2 border rounded-md cursor-pointer transition-all bg-white relative", 
            _ctx.selectedLayout === 'row' ? 'border-purple-600' : 'border-gray-300'
          ]),
              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.selectLayout('row')))
            }, [
              _createElementVNode("div", {
                class: _normalizeClass(["flex justify-between items-center p-4 rounded transition-colors", _ctx.selectedLayout === 'row' ? 'bg-purple-50' : 'bg-gray-100'])
              }, _cache[8] || (_cache[8] = [
                _createElementVNode("span", { class: "text-sm font-medium text-gray-500" }, "Row Layout", -1),
                _createElementVNode("img", {
                  src: _imports_2,
                  alt: "Custom Layout",
                  class: "w-26 h-26"
                }, null, -1)
              ]), 2),
              (_ctx.selectedLayout === 'row')
                ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                    _createElementVNode("div", {
                      innerHTML: _ctx.CHECK_CIRCLE,
                      class: "w-5 h-5"
                    }, null, 8, _hoisted_10)
                  ]))
                : _createCommentVNode("", true)
            ], 2)
          ]),
          (_ctx.showAlert)
            ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                _createElementVNode("div", _hoisted_12, [
                  (!_ctx.layoutName)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_13, " • Please enter a layout name "))
                    : _createCommentVNode("", true),
                  (!_ctx.selectedLayout)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_14, "• Please select a layout type"))
                    : _createCommentVNode("", true)
                ])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_15, [
            _createVNode(_component_BaseButton, {
              type: "button",
              onClick: _ctx.createLayout,
              class: "bg-primary-purple text-white px-6 py-2 rounded-md font-medium hover:bg-primary-purple/90"
            }, {
              default: _withCtx(() => _cache[9] || (_cache[9] = [
                _createTextVNode(" Create Layout ")
              ])),
              _: 1
            }, 8, ["onClick"])
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}